import { AlpineComponent } from 'alpinejs';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const Dialog = (): AlpineComponent => ({
  timeout: null,
  isDialogOpen: false,
  openDialog() {
    if (this.timeout) clearTimeout(this.timeout);
    disableBodyScroll(this.$refs.dialog);
    (this.$refs.dialog as HTMLDialogElement).showModal();
    this.isDialogOpen = true;
  },

  closeDialog() {
    enableBodyScroll(this.$refs.dialog);
    this.isNavOpen = false;
    this.timeout = setTimeout(() => {
      (this.$refs.dialog as HTMLDialogElement).close();
    }, 300);
  },
  init() {
    // Open dialog on button click
    const selector = `[data-js-dialog-toggle="${this.$refs.dialog.id}"]`;
    const toggle = document.querySelector(selector);

    document.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Escape' && (this.$refs.dialog as HTMLDialogElement).open) {
        this.closeDialog();
      }
    });

    if (toggle) {
      toggle.addEventListener('click', this.openDialog.bind(this));
    }
  }
});

export default Dialog;
